import React, { useEffect, useState } from "react";

import { authApi, getApiErrorMessage } from "../api";

const card = {
  background: "#fff",
  border: "1px solid #e2e8f0",
  borderRadius: 18,
  boxShadow: "0 10px 24px rgba(15,23,42,.05)",
  padding: 20,
};

const input = {
  width: "100%",
  boxSizing: "border-box",
  border: "1px solid #cbd5e1",
  borderRadius: 12,
  padding: "10px 12px",
  fontSize: 13,
  background: "#fff",
};

export default function SignatureUpload() {
  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState("");
  const [success, setSuccess] = useState("");
  const [file, setFile] = useState(null);
  const [form, setForm] = useState({
    signature_type: "DIRECTOR",
    person_name: "Gophal Bhati",
    person_designation: "Director",
  });

  const load = async () => {
    setLoading(true);
    try {
      const res = await authApi.get("/logistics/signatures");
      setRows(res.data?.data || []);
    } catch (err) {
      setError(getApiErrorMessage(err, "Failed to load signatures."));
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => { load(); }, []);

  const submit = async (event) => {
    event.preventDefault();
    if (!file) {
      setError("Please choose a signature image first.");
      return;
    }
    setSaving(true);
    setError("");
    setSuccess("");
    try {
      const payload = new FormData();
      payload.append("signature_file", file);
      payload.append("signature_type", form.signature_type);
      payload.append("person_name", form.person_name);
      payload.append("person_designation", form.person_designation);
      await authApi.post("/logistics/signatures", payload, {
        headers: { "Content-Type": "multipart/form-data" },
      });
      setSuccess("Signature uploaded successfully.");
      setFile(null);
      await load();
    } catch (err) {
      setError(getApiErrorMessage(err, "Failed to upload signature."));
    } finally {
      setSaving(false);
    }
  };

  return (
    <div style={{ display: "grid", gap: 20 }}>
      <div>
        <h2 style={{ margin: 0, fontSize: 26, fontWeight: 900, color: "#0f172a" }}>Organization Signatures</h2>
        <div style={{ marginTop: 6, color: "#475569", fontSize: 14 }}>Upload the active director or approver signature used on generated dispatch labels.</div>
      </div>

      <form onSubmit={submit} style={{ ...card, display: "grid", gap: 14 }}>
        {error ? <div style={{ color: "#b91c1c" }}>{error}</div> : null}
        {success ? <div style={{ color: "#166534" }}>{success}</div> : null}
        <div style={{ display: "grid", gridTemplateColumns: "repeat(3,minmax(0,1fr))", gap: 12 }}>
          <input style={input} value={form.signature_type} onChange={(e) => setForm((prev) => ({ ...prev, signature_type: e.target.value.toUpperCase() }))} placeholder="Signature type" />
          <input style={input} value={form.person_name} onChange={(e) => setForm((prev) => ({ ...prev, person_name: e.target.value }))} placeholder="Person name" />
          <input style={input} value={form.person_designation} onChange={(e) => setForm((prev) => ({ ...prev, person_designation: e.target.value }))} placeholder="Designation" />
        </div>
        <input type="file" accept=".png,.jpg,.jpeg" onChange={(e) => setFile(e.target.files?.[0] || null)} />
        <button type="submit" disabled={saving} style={{ width: "fit-content", border: 0, borderRadius: 12, background: "#0f172a", color: "#fff", padding: "11px 16px", fontWeight: 800, cursor: "pointer" }}>{saving ? "Uploading..." : "Upload Signature"}</button>
      </form>

      <div style={card}>
        <div style={{ fontSize: 18, fontWeight: 800, marginBottom: 14 }}>Uploaded Signatures</div>
        {loading ? <div>Loading signatures...</div> : rows.length === 0 ? <div style={{ color: "#64748b" }}>No signatures uploaded yet.</div> : (
          <div style={{ display: "grid", gap: 12 }}>
            {rows.map((row) => (
              <div key={row.id} style={{ border: "1px solid #e2e8f0", borderRadius: 14, padding: 16, display: "flex", justifyContent: "space-between", gap: 16, alignItems: "center" }}>
                <div>
                  <div style={{ fontWeight: 800 }}>{row.person_name}</div>
                  <div style={{ fontSize: 13, color: "#475569" }}>{row.signature_type} · {row.person_designation || "-"}</div>
                  <div style={{ fontSize: 12, color: "#64748b" }}>{row.uploaded_at ? new Date(row.uploaded_at).toLocaleString("en-IN") : "-"}</div>
                </div>
                {row.signature_image_path ? <img src={`${process.env.REACT_APP_API_URL || "http://127.0.0.1:5011/api/v1"}`.replace("/api/v1", "") + row.signature_image_path} alt={row.person_name} style={{ width: 180, height: 70, objectFit: "contain", background: "#f8fafc", borderRadius: 12 }} /> : null}
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}
